import React, { useContext, useEffect, useState } from "react";
import Layout from "../../components/layout/Layout";
import { Home2, SearchNormal1 } from "iconsax-react";
import SummaryCard from "../../components/common/SummaryCard";
import { BarCard, LineCard } from "../../components/charts";

import revenueIcon from "../../assets/svgs/revenue.svg";
import QuickActions from "./components/QuickActions";
import Table from "./components/Table";

import { StaticDateRangePicker } from "@mui/x-date-pickers-pro";
import { Box, Modal } from "@mui/material";
import { useFetchHomeCard, useFetchHomeCharts, useFetchHomeCharts2 } from "../../hooks/api/useHome";
import dayjs from "dayjs";
import LoadingState from "../../components/common/LoadingState";
import { ServiceContext } from "../../hooks/context/ServiceContext";

export const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "fit-content",
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: "20px",
  p: 4,
};
function Dashboard() {
  const [activeTab, setActiveTab] = useState<string>("web-visit");
  const [activitiesTab, setActivitiesTab] = useState<string>("all");

  const [selectedValues, setSelectedValues] = useState<string[]>([]);
  const handleCheckboxChange = (value: string, isChecked: boolean) => {
    if (isChecked) {
      setSelectedValues([...selectedValues, value]); // Add value to selectedValues
    } else {
      setSelectedValues(selectedValues.filter((v) => v !== value)); // Remove value from selectedValues
    }
  };

  const handleTabClick = (tabId: string) => {
    setActiveTab(tabId);
  };
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [startDate, setStartDate] = useState<any>(dayjs());
  const [activeTimeLine, setActiveTimeLine] = useState("week");
  const [endDate, setEndDate] = useState<any>(dayjs());
  const { data, refetch: refetchHomeCard, isLoading: homeCardLoading, isFetching: homeCardFetching } = useFetchHomeCard({ interval: activeTimeLine, startDate, endDate });
  const {
    data: homeCharts,
    refetch: refetchHomeChart,
    isLoading: homeChartLoading,
    isFetching: homeChartFetching,
  } = useFetchHomeCharts({ interval: activeTimeLine, startDate, endDate, activities: activitiesTab });
  const {
    data: homeCharts2,
    
  } = useFetchHomeCharts2({ interval: activeTimeLine, startDate, endDate, activities: activitiesTab });
  const { service } = useContext(ServiceContext);
console.log({homeCharts2})

  const handleTimeline = () => {
    if (activeTimeLine !== "custom") {
   
      setStartDate(dayjs().startOf(activeTimeLine as "week").format("YYYY-MM-DD"))
      setEndDate(dayjs().endOf(activeTimeLine as "week").format("YYYY-MM-DD"))
    }
   refetchHomeCard();
    refetchHomeChart();
  };


  useEffect(() => {
    refetchHomeCard();
    refetchHomeChart();
  }, [service]);

  useEffect(() => {
    refetchHomeChart();
  }, [activitiesTab]);
  return (
    <Layout
      pageName="Home"
      icon={<Home2 size={38} />}
      handleOpenCalendar={handleOpen}
      activeTimeLine={activeTimeLine}
      setActiveTimeLine={setActiveTimeLine}
      handleTimeLine={handleTimeline}
      showMetrics={false}
      showTimeLine={true}
      showFilter2={false}
    >
      {homeCardLoading || homeChartLoading || homeCardFetching || homeChartFetching ? (
        <LoadingState />
      ) : (
        <>
          <div className="grid grid-cols-4 mt-2 gap-2">
            <SummaryCard
              className="w-full"
              // icon={<EmptyWallet className="h-10 w-10" color="#2C625F" />}
              isIcon={true}
              titleHeading="Total Revenue"
              totalHeading={data?.revenueCard?.totalRevenue}
              sectionOneTitle="New Subscribers"
              sectionOneCount={data?.revenueCard?.newSubscriber.amount}
              sectionOneTotal={data?.revenueCard?.newSubscriber.changes}
              sectionTwoTitle="Renewals"
              sectionTwoCount={data?.revenueCard?.renewSubscriber.amount}
              sectionTwoTotal={data?.revenueCard?.renewSubscriber.changes}
            />
            <SummaryCard
              className="w-full"
              icon={revenueIcon}
              // icon={<Refresh className="h-8 w-8" color="#2C625F" />}
              isIcon={true}
              titleHeading="Total Subcribers"
              totalHeading={data?.subscriberCard?.totalSubscriber}
              sectionOneTitle="This Week"
              sectionOneCount={data?.subscriberCard?.present.subscriberPresent}
              sectionOneTotal={data?.subscriberCard?.present.changes}
              sectionTwoTitle="Last Week"
              sectionTwoCount={data?.subscriberCard?.previous.subscriberPrevious}
              sectionTwoTotal={data?.subscriberCard?.previous.changes}
            />
            <SummaryCard
              className="w-full"
              icon={revenueIcon}
              // icon={<Refresh className="h-8 w-8" color="#2C625F" />}
              isIcon={true}
              titleHeading="Total Subscriptions"
              totalHeading={data?.subscriptionCard?.totalSubscription}
              sectionOneTitle="This Week"
              sectionOneCount={data?.subscriptionCard?.present.subscriptionPresent}
              sectionOneTotal={data?.subscriptionCard?.present.changes}
              sectionTwoTitle="Last Week"
              sectionTwoCount={data?.subscriptionCard?.previous.subscriptionPrevious}
              sectionTwoTotal={data?.subscriptionCard?.previous.changes}
            />
            <SummaryCard
              className="w-full"
              icon={revenueIcon}
              // icon={<Refresh className="h-8 w-8 font-semibold" color="#2C625F" />}
              isIcon={true}
              titleHeading="Active Players"
              totalHeading={data?.scoreCard.totalPlayer}
              sectionOneTitle="This Week"
              sectionOneCount={data?.scoreCard?.present.scorePresent}
              sectionOneTotal={data?.scoreCard?.present.changes}
              sectionTwoTitle="Last Week"
              sectionTwoCount={data?.scoreCard?.previous.scorePrevious}
              sectionTwoTotal={data?.scoreCard?.previous.changes}
            />
          </div>
          <div className="grid grid-cols-2 mt-10 gap-2">
            <div className="">
              <QuickActions />

              <div className="mt-10 p-5 bg-white rounded-md">
                <div className="mb-4 border rounded-md border-gray-200 w-fit">
                  <ul className="flex flex-wrap -mb-px text-sm font-medium text-center" id="default-styled-tab" role="tablist">
                    <li className="me-2" role="presentation">
                      <button
                        className={`${
                          activeTab === "web-visit" ? "text-primary" : "text-gray-400"
                        } text-sm inline-block p-2 pb-0 mb-2 border-b rounded-t-lg  hover:border-gray-300 dark:hover:text-gray-300`}
                        onClick={() => {
                          handleTabClick("web-visit");
                        }}
                      >
                        Web Visits
                      </button>
                    </li>
                    <li className="me-2" role="presentation">
                      <button
                        className={`${
                          activeTab === "subscriptions" ? "text-primary" : "text-gray-400"
                        } text-sm inline-block p-2 pb-0 mb-2 border-b rounded-t-lg  hover:border-gray-300 dark:hover:text-gray-300`}
                        onClick={() => {
                          handleTabClick("subscriptions");
                        }}
                      >
                        Subscriptions
                      </button>
                    </li>
                    <li className="me-2">
                      <button
                        className={`${
                          activeTab === "revenue" ? "text-primary" : "text-gray-400"
                        } text-sm inline-block p-2 pb-0 mb-2 border-b rounded-t-lg  hover:border-gray-300 dark:hover:text-gray-300`}
                        onClick={() => {
                          handleTabClick("revenue");
                        }}
                      >
                        Revenue
                      </button>
                    </li>
                    <li className="me-2" role="presentation">
                      <button
                        className={`${
                          activeTab === "subscribers" ? "text-primary" : "text-gray-400"
                        } text-sm inline-block p-2 pb-0 mb-2 border-b rounded-t-lg  hover:border-gray-300 dark:hover:text-gray-300`}
                        onClick={() => {
                          handleTabClick("subscribers");
                        }}
                      >
                        Subscribers
                      </button>
                    </li>
                  </ul>
                </div>
                <div className={`tab-content ${activeTab === "web-visit" ? "block" : "hidden"}`} id="styled-web-visit">
                  {/* Web Visits content goes here */}
                  <LineCard
                    bgcolor="#FBFBFB"
                    colors={["#2F3D59", "#EFF2FD"]}
                    series={[
                      {
                        data: homeCharts?.lineGraph?.webVisitArr?.map((data: { count: number }) => data.count),
                        name: "Subscribers",
                      },
                    ]}
                    title="Web Visits"
                    details="No. OF VISITORS"
                    percentageChange={20}
                    yAxisLabel="Number of Subscribers"
                    xAxis={homeCharts?.lineGraph?.webVisitArr.map((data: { day: string, date?:string }) => data?.day?.slice(0, 3) || data?.date)} // hasGradient={true}
                  />
                </div>

                <div className={`tab-content ${activeTab === "subscriptions" ? "block" : "hidden"}`} id="styled-subscriptions">
                  <BarCard
                    bgcolor="#FBFBFB"
                    colors={["#FADFD7", "#828A9B", "#061638"]}
                    // colors={["#071839"]}
                    series={[
                      {
                        data: homeCharts?.lineGraph?.subscriptionArr.map((data: { subscriptionDaily: number }) => data.subscriptionDaily),
                        name: "Daily Subscription",
                      },
                      {
                        data: homeCharts?.lineGraph?.subscriptionArr.map((data: { subscriptionWeekly: number, count:number }) => data.subscriptionWeekly|| data?.count),
                        name: "Weekly Subscription",
                      },
                      {
                        data: homeCharts?.lineGraph?.subscriptionArr.map((data: { subscriptionMonthly: number }) => data.subscriptionMonthly),
                        name: "Monthly Subscription",
                      },
                    ]}
                    title="Subscriptions"
                    details="No. of subscriptions"
                    percentageChange={20}
                    yAxisLabel="Number of Subscriptions"
                    xAxis={homeCharts?.lineGraph?.subscriptionArr.map((data: { day: string , date:string}) => data?.day?.slice(0, 3)||data.date)}
                    // hasGradient={true}
                  />
                </div>
                <div className={`tab-content ${activeTab === "revenue" ? "block" : "hidden"}`} id="styled-subscriptions">
                  <BarCard
                    bgcolor="#FBFBFB"
                    colors={["#2F3D59", "#CDD0D7"]}
                    // colors={["#071839"]}
                    series={[
                      {
                        data: homeCharts?.lineGraph?.revenueArr.map((data: { revenueNew: number }) => data.revenueNew),
                        name: "New Subscribers",
                      },
                      {
                        data: homeCharts?.lineGraph?.revenueArr.map((data: { revenueRen: number }) => data.revenueRen),
                        name: "Renewals",
                      },
                    ]}
                    title="Revenue"
                    details="This Week"
                    percentageChange={20}
                    yAxisLabel="Amount"
                    xAxis={homeCharts?.lineGraph?.revenueArr.map((data: { day: string , date:string}) => data?.day?.slice(0, 3)||data.date)}
                    // hasGradient={true}
                  />
                </div>
                <div className={`tab-content ${activeTab === "subscribers" ? "block" : "hidden"}`} id="styled-subscriptions">
                  <LineCard
                    bgcolor="#FBFBFB"
                    colors={["#2F3D59", "#EFF2FD"]}
                    series={[
                      {
                        data: homeCharts?.lineGraph?.subscriberArr.map((data: { count: number }) => data.count),
                        name: "Subscriber",
                      },
                    ]}
                    title="Subscribers"
                    details="No. of Subcribers"
                    percentageChange={20}
                    yAxisLabel="Number of Subscribers"
                    xAxis={homeCharts?.lineGraph?.subscriberArr.map((data: { day: string }) => data?.day?.slice(0, 3))} // hasGradient={true}
                  />
                </div>
              </div>
            </div>

            <div>
              <Table data={homeCharts?.activities} setActiveTab={setActivitiesTab} activeTab={activitiesTab} />
            </div>
          </div>
        </>
      )}


{service==="glo"?<div className="my-4 w-full flex flex-wrap">
  <div className="w-full">
    
  <BarCard series={
    [
      {
      data: homeCharts2?.overallArr?.map(i => i.daily_sub) || [],
      name: "Daily Subscriptions"
    },
      {
      data: homeCharts2?.overallArr?.map(i => i.weekly_sub) || [],
      name: "Weekly Subscriptions"
    },
      {
      data: homeCharts2?.overallArr?.map(i => i.monthly_sub) || [],
      name: "Monthly Subscriptions"
    },
  
  ]
  } 
  bgcolor="#FBFBFB"
  colors={["#061638", "#828A9B", "#FADFD7"]}
  title="Subscription"
   yAxisLabel="No of Subscribers" 
   xAxis={homeCharts2?.overallArr?.map(i => i.endDate)||[] }
   />
  </div>

<div className="w-full mt-4">

<BarCard series={
    [
      {
      data: homeCharts2?.revenueChartArr.map(i=>i.new_subscriber_revenue) || [],
      name: "New Subscriptions"
    },
      {
      data: homeCharts2?.revenueChartArr.map(i=>i.renewals) || [],
      name: "Renewals Subscriptions"
    },
  
  ]
  } 
  bgcolor="#FBFBFB"
  colors={["#061638", "#828A9B", "#FADFD7"]}
  title="Revenue"
   yAxisLabel=" Amount (₦)" 
   xAxis={homeCharts2?.overallArr?.map(i => i.endDate)||[] }
   />
 
   </div>
</div>:null}


      <Modal open={open} onClose={handleClose}>
        <Box sx={style}>
          <StaticDateRangePicker
            calendars={2}
            slotProps={{
              actionBar: { actions: [] },
            }}
            onChange={(date: any) => {
              const formattedStartDate = dayjs(date[0]).format("YYYY-MM-DD");
              const formattedEndDate = dayjs(date[1]).format("YYYY-MM-DD");
              if (dayjs(formattedStartDate).isValid() && dayjs(formattedEndDate).isValid()) {
                setStartDate(formattedStartDate);
                setEndDate(formattedEndDate);
                handleClose();
                refetchHomeCard();
                refetchHomeChart();
              }
            }}
          />
        </Box>
      </Modal>
    </Layout>
  );
}

export default Dashboard;